// extracted by mini-css-extract-plugin
module.exports = {"square-button":"_Button_square-button_3M9BJ"};